import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewEncapsulation,
} from '@angular/core';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-dialog',
	styleUrls: ['./dialog.component.scss'],
	templateUrl: './dialog.component.html',
})
export class DialogComponent {
	@Input() public asAlert = false;
	@Output() dialogClose = new EventEmitter<void>();
	@Output() dialogSave = new EventEmitter<void>();
	@Input() public disabled = false;
	@Input() public hideFooter = false;
	@Input() public modalTitle = '';
	@Input() public noMargins = false;
	@Input() public secButton = false;
	@Input() public secTitleButton = '';
	@Input() public titleButton = '';
}
